<script>
export default {
}
</script>

<template>
  <div>
    <slot />
  </div>
  
</template>


// WEBPACK FOOTER //
// src/layouts/LoginLayout.vue